import API from './resources'

const actions = {
  async allLogs({ commit, state }, payload) {
    try {
      if (payload.email === undefined) {
        const response = await API.allLogs(
          state.current_page,
          state.page_size,
          // state.email,
          payload.token
        )

        commit('SET_PUSH_LIST', response)
        return response
      } else {
        const response = await API.filterLogs(
          state.current_page,
          state.page_size,
          state.email,
          state.search_message,
          payload.token
        )
        commit('SET_PUSH_LIST', response)
        return response
      }
    } catch (error) {
      return error
    }
  },
  async allPushWebSchedules({ commit, state }, payload) {

    try {
      let search = payload.search ? payload.search : ""; 
      let page = state.current_page;

      if(page > 0)
        page--; 
      
      const response = await API.allPushWebSchedules(
        page,
        state.page_size,
        search,
        payload.token
      )

      commit('SET_PUSH_LIST', response)
      return response;
    } catch (error) {
      console.error(error);
    }
  },

  async allPushWebLogs({ commit, state }, payload) {

    try {
      commit('SET_PUSHLOGS_LIST', [])

      let search = payload.search ? payload.search : ""; 

      const response = await API.allLogs(
        state.current_page ? state.current_page : 1,
        state.page_size ,
        search,
        payload.token
      )

      commit('SET_PUSHLOGS_LIST', response)
      return response;
    } catch (error) {
      console.error(error);
    }
  },

  async getService({ commit }, payload) {
    try {
      const response = await API.getServices(
        payload.token
      )
      commit('SET_SERVICE', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async updateMessage({ commit }, payload) {
    let data, token
    [data, token] = payload
    try {
      const response = await API.updateMessages(data, token)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/push_web/actions.js